








import Vue from 'vue'
export default Vue.extend({
  name: 'Message',
  props: {
    messageType: {
      type: String,
      default: 'success',
      validator: (value) => {
        return ['success', 'info', 'warning', 'danger'].indexOf(value) !== -1
      }
    },
    message: {
      type: String,
      required: true
    }
  },
  computed: {
    messageClass (): string {
      return 'alert-' + this.messageType
    }
  }
})
